module.exports = __webpack_public_path__ + "static/media/loader.1385f237.gif";